












import Vue from 'vue';
import { IStyleObject } from '@/common/interfaces/index.interface';

interface IState{
  icon: string | false;
}

interface IToggleIconComponent{
  toggled: boolean;
}

export default Vue.extend({
  data() : IToggleIconComponent {
    return {
      toggled: false,
    };
  },
  computed: {
    rotateIcon(): IStyleObject {
      return this.overrideToggle ? { transform: `rotate(${this.rotate}deg)` } : {};
    },
    showIcon(): string | boolean {
      if(this.toggled && this.toggledState.icon) {
        return this.toggledState.icon;
      }
      return this.defaultState.icon;
    },
  },
  props: {
    defaultState: {
      type: Object as () => IState,
      default: () => ({ icon: false }),
    },
    overrideToggle: {
      default: false,
      type: Boolean,
    },
    rotate: {
      default: 0,
      type: Number,
    },
    toggledState: {
      default: () => ({ icon: null }),
      type: Object as () => { icon: string | null },
    },
  },
  methods: {
    toggle() {
      if(!this.overrideToggle) {
        this.toggled = !this.toggled;
      }
    },
  },
});
